module.exports = __webpack_public_path__ + "img/arrowhead1.f7cb67dc.png";